import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import { readerConsentReplySchema } from "@bindery/shared/contracts/orientation-secure";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const CONSENT_PATH = `${ORIENTATION_API_PREFIX}/consent`;

export const consentRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
});
export type ConsentRequest = z.infer<typeof consentRequestSchema>;

/** Whether and when the reader's study consent was signed, never by whom. */
export const consentResponseSchema = readerConsentReplySchema;
export type ConsentResponse = z.infer<typeof consentResponseSchema>;
